<!-- Loading bar -->
<zop-loading-bar></zop-loading-bar>

<!-- bg-gradient-to-b from-[#FE4F30] from-10% to-[#E12A6D] to-70% -->
<div class="flex w-full h-screen overflow-hidden">
    <!-- Navigation -->
    <zop-vertical-navigation
        class="bg-[#E12A6D] text-white font-medium print:hidden flex-shrink-0 h-full"
        [appearance]="navigationAppearance"
        [mode]="isScreenSmall ? 'over' : 'side'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="!isScreenSmall"
    >
        <!-- Navigation header hook -->
        <ng-container zopVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center justify-center h-20">
                <img
                    class="w-8"
                    src="assets/images/logo/zop-logo-dark.svg"
                    alt="Logo image"
                />
            </div>
        </ng-container>
    </zop-vertical-navigation>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full min-w-0 h-full overflow-hidden">
        <!-- Header -->
        <div
            *ngIf="!config?.hideHeader"
            class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-transparent dark:bg-transparent print:hidden"
        >
            <div class="flex items-center pr-2 space-x-2">
                <!-- Navigation toggle button -->
                <button
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                <!-- Navigation appearance toggle button -->
                <button
                    class="hidden md:inline-flex"
                    mat-icon-button
                    (click)="toggleNavigationAppearance()"
                >
                    <mat-icon
                        [svgIcon]="'heroicons_outline:arrows-right-left'"
                    ></mat-icon>
                </button>
            </div>
            <!-- Components -->
            <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
                <zop-languages></zop-languages>
                <zop-full-screen class="hidden md:block"></zop-full-screen>
                <zop-shortcuts></zop-shortcuts>
                <zop-notifications></zop-notifications>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto min-h-0 overflow-y-auto">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

        <!-- Footer -->
        <div
            *ngIf="!config?.hideFooter"
            class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
        >
            <span class="font-medium text-secondary"
                >{{ config.copyWriteText }} &copy; {{ currentYear }}</span
            >
        </div>
    </div>
</div>
